import {OrderOption} from '../../model/order-option';


export const ONE_MONTH_TERM = '1';
export const SIX_MONTHS_TERM = '6';
export const TWELVE_MONTHS_TERM = '12';

const OneMonthOption: OrderOption = {
  name: 'one-month',
  descriptionKey: 'eos-tv-shop-ii.text.pack-option-one-month',
  titleKey: 'eos-tv-shop-ii.title.pack-option-one-month',
  term: ONE_MONTH_TERM,
  priceDetail: null
};

const SixMonthsOption: OrderOption = {
  name: 'six-months',
  titleKey: 'eos-tv-shop-ii.title.pack-option-six-months',
  term: SIX_MONTHS_TERM,
  priceDetail: null
};

const TwelveMonthsOption: OrderOption = {
  name: 'twelve-months',
  titleKey: 'eos-tv-shop-ii.title.pack-option-twelve-months',
  term: TWELVE_MONTHS_TERM,
  priceDetail: null
};

export const PackOptionsForStreamz: Array<OrderOption> = [
  OneMonthOption,
  {...SixMonthsOption, discount: -2, descriptionKey: 'eos-tv-shop-ii.text.streamz-option-six-months'},
  {...TwelveMonthsOption, discount: -3, descriptionKey: 'eos-tv-shop-ii.text.streamz-option-twelve-months'}
];

export const PackOptionsForStreamzB2B: Array<OrderOption> = [
  OneMonthOption,
  {...SixMonthsOption, discount: -1.65, descriptionKey: 'eos-tv-shop-ii.text.streamz-option-six-months'},
  {...TwelveMonthsOption, discount: -2.48, descriptionKey: 'eos-tv-shop-ii.text.streamz-option-twelve-months'}
];

export const PackOptionsForStreamzBasic: Array<OrderOption> = [
  OneMonthOption,
  {...SixMonthsOption, discount: -1, descriptionKey: 'eos-tv-shop-ii.text.streamz-basic-option-six-months'},
  {...TwelveMonthsOption, discount: -2, descriptionKey: 'eos-tv-shop-ii.text.streamz-basic-option-twelve-months'}
];

export const PackOptionsForStreamzBasicB2B: Array<OrderOption> = [
  OneMonthOption,
  {...SixMonthsOption, discount: -0.83, descriptionKey: 'eos-tv-shop-ii.text.streamz-basic-option-six-months'},
  {...TwelveMonthsOption, discount: -1.65, descriptionKey: 'eos-tv-shop-ii.text.streamz-basic-option-twelve-months'}
];
